import { useEffect } from "react";

export function useEditorialMotion(rootRef, routeKey = "") {
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return undefined;
    const preference = window.matchMedia("(prefers-reduced-motion: reduce)");
    let frame = 0;
    let observer;
    const hero = root.querySelector("[data-scene-hero]");
    let lastProgress;
    let lastScrolled;
    const paint = () => {
      frame = 0;
      const rect = hero?.getBoundingClientRect();
      const progress = !rect || (preference.matches || document.documentElement.dataset.reduceMotion === "true") ? 0 : Math.max(0, Math.min(1, -rect.top / Math.max(1, rect.height)));
      const value = progress.toFixed(4);
      if (hero && value !== lastProgress) { hero.style.setProperty("--scene-progress", value); lastProgress = value; }
      const scrolled = window.scrollY > 25;
      if (scrolled !== lastScrolled) { root.dataset.scrolled = String(scrolled); lastScrolled = scrolled; }
    };
    const schedule = () => { if (!frame) frame = window.requestAnimationFrame(paint); };
    if ("IntersectionObserver" in window) {
      observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add("is-visible"); observer.unobserve(entry.target); }
      }), { threshold: 0.08 });
      root.querySelectorAll("[data-cinema-reveal]").forEach((el) => observer.observe(el));
      root.dataset.motionReady = "true";
    }
    paint();
    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("damerow-motion-change", schedule);
    window.addEventListener("resize", schedule);
    preference.addEventListener("change", schedule);
    return () => {
      observer?.disconnect();
      window.cancelAnimationFrame(frame);
      window.removeEventListener("scroll", schedule);
      window.removeEventListener("damerow-motion-change", schedule);
      window.removeEventListener("resize", schedule);
      preference.removeEventListener("change", schedule);
    };
  }, [rootRef, routeKey]);
}
